import { z } from "zod";

export const getOrderParamSchema = z.object({
	orderId: z.uuid(),
});

export type GetOrderParamSchema = z.infer<typeof getOrderParamSchema>;
